import React from 'react';
import { FileCheck, Building, Database, Share2, UserCog, Edit } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const AvisoPrivacidad = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <section className="bg-gradient-to-r from-[#1e3a8a] to-[#1e40af] text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 flex items-center gap-3">
            <FileCheck className="h-12 w-12" />
            Aviso de Privacidad
          </h1>
          <p className="text-xl opacity-90">Mora BioVet Laboratorio Veterinario</p>
        </div>
      </section>

      <div className="max-w-4xl mx-auto px-4 py-12">
        <Card className="shadow-lg mb-6">
          <CardContent className="p-8">
            <h2 className="text-2xl font-bold text-[#1e3a8a] mb-4 flex items-center gap-2">
              <Building className="h-6 w-6 text-[#84cc16]" />
              Identidad del responsable
            </h2>
            <p className="text-gray-700">
              <strong>Mora BioVet Laboratorio Veterinario</strong> es responsable del tratamiento de los datos personales.
            </p>
          </CardContent>
        </Card>

        <Card className="shadow-lg mb-6">
          <CardContent className="p-8">
            <h2 className="text-2xl font-bold text-[#1e3a8a] mb-4 flex items-center gap-2">
              <Database className="h-6 w-6 text-[#84cc16]" />
              Datos que se recaban
            </h2>
            <ul className="space-y-2 text-gray-700">
              <li className="flex items-start gap-2">
                <span className="text-[#84cc16] font-bold mt-1">•</span>
                <span>Nombre</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#84cc16] font-bold mt-1">•</span>
                <span>Teléfono</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#84cc16] font-bold mt-1">•</span>
                <span>Correo electrónico</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#84cc16] font-bold mt-1">•</span>
                <span>Información del paciente</span>
              </li>
            </ul>
          </CardContent>
        </Card>

        <Card className="shadow-lg mb-6">
          <CardContent className="p-8">
            <h2 className="text-2xl font-bold text-[#1e3a8a] mb-4">Finalidad del tratamiento</h2>
            <p className="text-gray-700 mb-4">Los datos serán utilizados para:</p>
            <ul className="space-y-2 text-gray-700">
              <li className="flex items-start gap-2">
                <span className="text-[#84cc16] font-bold mt-1">•</span>
                <span>Prestación de servicios de laboratorio</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#84cc16] font-bold mt-1">•</span>
                <span>Contacto y seguimiento</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#84cc16] font-bold mt-1">•</span>
                <span>Facturación</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#84cc16] font-bold mt-1">•</span>
                <span>Mejora del servicio</span>
              </li>
            </ul>
          </CardContent>
        </Card>

        <Card className="shadow-lg mb-6">
          <CardContent className="p-8">
            <h2 className="text-2xl font-bold text-[#1e3a8a] mb-4 flex items-center gap-2">
              <Share2 className="h-6 w-6 text-[#84cc16]" />
              Transferencia de datos
            </h2>
            <p className="text-gray-700">
              Los datos no serán compartidos sin consentimiento, salvo obligación legal.
            </p>
          </CardContent>
        </Card>

        <Card className="shadow-lg mb-6 bg-gradient-to-br from-blue-50 to-white">
          <CardContent className="p-8">
            <h2 className="text-2xl font-bold text-[#1e3a8a] mb-4 flex items-center gap-2">
              <UserCog className="h-6 w-6 text-[#84cc16]" />
              Medios para ejercer derechos ARCO
            </h2>
            <p className="text-gray-700 mb-4">
              El usuario puede enviar solicitud a través de los medios de contacto publicados en la página web.
            </p>
            <div className="bg-white p-4 rounded-lg">
              <p className="text-gray-700">
                <strong>Email:</strong> <a href="mailto:info@morabiovet.com" className="text-[#1e40af] hover:underline">info@morabiovet.com</a>
              </p>
              <p className="text-gray-700 mt-2">
                <strong>Teléfono:</strong> 555-123-4567
              </p>
            </div>
          </CardContent>
        </Card>

        <Card className="shadow-lg mb-6">
          <CardContent className="p-8">
            <h2 className="text-2xl font-bold text-[#1e3a8a] mb-4 flex items-center gap-2">
              <Edit className="h-6 w-6 text-[#84cc16]" />
              Cambios al aviso de privacidad
            </h2>
            <p className="text-gray-700">
              Cualquier modificación será publicada en el sitio web oficial.
            </p>
          </CardContent>
        </Card>

        <Card className="shadow-lg mb-6 bg-gradient-to-r from-green-50 to-blue-50">
          <CardContent className="p-8">
            <h2 className="text-2xl font-bold text-[#1e3a8a] mb-4">Consentimiento</h2>
            <p className="text-gray-700">
              Al proporcionar sus datos, el usuario acepta el tratamiento conforme a este aviso de privacidad.
            </p>
          </CardContent>
        </Card>

        <div className="bg-blue-50 border-l-4 border-[#1e40af] p-6 rounded-lg mt-8">
          <p className="text-gray-700 font-semibold mb-2">
            Domicilio del responsable:
          </p>
          <p className="text-gray-600">
            Cenzontle 137, Palo Solo, 52778 Huixquilucan de Degollado, Estado de México
          </p>
          <p className="text-gray-600 mt-4 text-sm">
            <strong>Fecha de última actualización:</strong> Marzo 2026
          </p>
        </div>
      </div>
    </div>
  );
};

export default AvisoPrivacidad;